module.exports = "<div class=chapter-text> {{{ content }}} </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StoryChapter.vue
 ** module id = 76
 ** module chunks = 0
 **/